'use client';

import { QueryClient } from 'react-query';

// Define query keys for auth - reusing from useSharedAuth
export const AUTH_QUERY_KEYS = {
  session: 'auth-session',
  token: 'auth-token',
};

// Create a global QueryClient that exists only on the client side
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // 1 minute
      cacheTime: 300000, // 5 minutes
    },
  },
});
